import axios from 'axios';
import React from 'react';
import '../styles/AuthMethodButtons.css';
import { isAbortError } from '../isAbortError.js';
import { useAbortController } from '../../Shared/hooks/useAbortController.js';
import { saveAuthReturnTo, validateReturnTo } from '../../Shared/utils/authReturnTo.js';

export default function GoogleLoginButton({ withoutAction, returnTo }) {
    const { nextSignal } = useAbortController();

    const handleLoginClick = async (event) => {
        event.preventDefault();
        if (withoutAction) return;

        const validatedReturnTo = validateReturnTo(returnTo);
        if (validatedReturnTo) {
            saveAuthReturnTo(validatedReturnTo);
        }

        try {
            const authUrl = validatedReturnTo
                ? `${import.meta.env.VITE_BASE_URL}/auth/google?returnTo=${encodeURIComponent(validatedReturnTo)}`
                : `${import.meta.env.VITE_BASE_URL}/auth/google`;

            const response = await axios.get(authUrl, {
                signal: nextSignal('google-auth'),
            });
            window.location.href = response.data;
        } catch (error) {
            if (!isAbortError(error)) {
                console.error('Error fetching Google auth URL', error);
            }
        }
    };

    return (
        <button type="button" className="auth-method__button" onClick={handleLoginClick}>
            <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="none" viewBox="0 0 35 35">
                <defs>
                    <clipPath id="clip229_159">
                        <path fill="#fff" fillOpacity="0" d="M0 0H35V35H0z"></path>
                    </clipPath>
                    <clipPath id="clip229_157">
                        <path fill="#fff" fillOpacity="0" d="M0 0H35V35H0z"></path>
                    </clipPath>
                </defs>
                <g clipPath="url(#clip229_157)">
                    <g fillOpacity="1" fillRule="nonzero" clipPath="url(#clip229_159)">
                        <path fill="#4285F4" d="M34.62 17.89c0-1.15-.1-2.25-.27-3.31H17.87v6.58h9.43c-.42 2.15-1.66 3.98-3.5 5.22v4.37h5.63c3.3-3.05 5.19-7.54 5.19-12.86z"></path>
                        <path fill="#34A853" d="M17.87 35c4.72 0 8.67-1.58 11.56-4.25l-5.63-4.37c-1.57 1.05-3.57 1.69-5.93 1.69-4.57 0-8.43-3.08-9.82-7.24h-5.8v4.51C5.12 31.06 11.03 35 17.87 35z"></path>
                        <path fill="#FBBC05" d="M8.05 20.83c-.36-1.05-.55-2.17-.55-3.33 0-1.17.2-2.29.55-3.34V9.65h-5.8A17.25 17.25 0 00.37 17.5c0 2.82.68 5.48 1.88 7.84l5.8-4.51z"></path>
                        <path fill="#EA4335" d="M17.87 6.92c2.58 0 4.88.89 6.71 2.63l4.98-4.99C26.54 1.73 22.59 0 17.87 0 11.03 0 5.12 3.93 2.25 9.65l5.8 4.51C9.44 10 13.3 6.92 17.87 6.92z"></path>
                    </g>
                </g>
            </svg>
            <p>
                Sign up with Google
            </p>
        </button>
    );
}
